import React, { useState, useEffect } from 'react'
import { compose, isEmpty } from 'ramda'
import MediaQuery from 'react-responsive'
import { LoadingComponent } from '@pga/pga-component-library'
import { withAlgoliaClient, mergeHtmlByRanking } from '../utils/algolia'
import PageContainer from '../components/PageContainer'
import DesktopView from './DesktopView'
import MobileView from './MobileView'

export const DetailPage = ({ algoliaClient, match }) => {
  const [hit, setHit] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        setLoading(true)
        const { hits } = await algoliaClient.search('', {
          filters: `slug:"${match.params.slug}"`,
          distinct: false,
          hitsPerPage: 200
        })
        const hit = mergeHtmlByRanking(hits)
        setHit(hit)
      } catch (error) {
        console.error('Error fetching event details:', error)
      } finally {
        setLoading(false)
      }
    }

    if (match.params.slug) {
      fetchEventDetails()
    }

    window.scrollTo(0, 0)
  }, [algoliaClient, match.params.slug])

  if (loading || isEmpty(hit)) {
    return <LoadingComponent />
  }

  return (
    <PageContainer bgColor='white'>
      <MediaQuery minWidth={992}>
        <DesktopView hit={hit} />
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <MobileView hit={hit} />
      </MediaQuery>
    </PageContainer>
  )
}

export default compose(withAlgoliaClient)(DetailPage)
